<template>
  <div class='mainContainer' v-loading="importLoading">
    <div class='nav'>
      <el-form :model='searchForm' label-width='130px' :inline='true'>
        <el-form-item label='供应商：'>
          <el-input v-model='searchForm.supplierName' size='mini' placeholder='请输入供应商' />
        </el-form-item>
        <el-form-item label='港口/库房名称：'>
          <el-input v-model='searchForm.name' size='mini' placeholder='请输入港口/库房名称' />
        </el-form-item>
        <el-form-item label='结算类型：'>
          <el-select v-model='searchForm.settlementType' size='mini' filterable style='width:100%'
                     placeholder='请选择结算类型' value-key='id'>
            <el-option label='全部' value='' />
            <el-option label='库房' :value='0' />
            <el-option label='港口' :value='1' />
          </el-select>
        </el-form-item>
        <el-form-item label='台账月：'>
          <el-date-picker v-model='searchForm.standingBookMonth' size='mini' value-format='yyyy-MM'
                          type='month' placeholder='请选择台账月' />
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='searchForm.brand' size='mini' placeholder='请输入品牌' />
        </el-form-item>
        <el-form-item label='原结算对账编号：' label-width="130px">
          <el-input v-model='searchForm.actNoSub' size='mini' placeholder='请输入原结算对账编号'  style="width: 170px"/>
        </el-form-item>
        <el-form-item label='原结算对账标题：' label-width="130px">
          <el-input v-model='searchForm.titleSub' size='mini' placeholder='请输入原结算对账标题' />
        </el-form-item>
        <el-form-item label='是否生成对账单:'>
          <el-select v-model='searchForm.isReconciliation' size='mini' placeholder='请选择是否生成对账单'>
            <el-option label='全部' value='' />
            <el-option label='是' :value='1' />
            <el-option label='否' :value='0' />
            <el-option label='部分生成' :value='2' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
            查询
          </el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='generateStatement'>生成对账单</el-button>
          <el-button size='small' type='primary' @click='refreshBtn'>刷新补结算</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' @importSuccess='searchBtn'
                        @changeImportLoading='changeImportLoading' :type='27'/>
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :reserve-selection='true'
        @select='selectionChange'
        @select-all='selectionChange'
        :row-style="rowStyle"
      >
        <el-table-column type='selection' align='center' min-width='50'
                         :selectable='(row)=>{return row.isReconciliation !== 1}' />
        <el-table-column label='供应商' prop='supplierName' align='center' />
        <el-table-column label='结算类型' prop='settlementType' align='center'
                         :formatter='settlementTypeFormat' />
        <el-table-column label='港口/库房名称' prop='name' align='center' width="130"/>
        <el-table-column label='台账月' prop='standingBookMonth' align='center' />
        <el-table-column label='作业时间' prop='taskDate' align='center' />
        <el-table-column label='品牌' prop='brand' align='center' />
        <el-table-column label='作业类型' prop='taskType' align='center' />
        <el-table-column label='作业数量' prop='taskNum' align='center' />
        <el-table-column label='结算方式' prop='settlementStyle' align='center'
                         :formatter='settlementStyleFormat' />
        <el-table-column label='税率（%）' prop='taxRate' align='center' width="90"/>
        <el-table-column prop='taxContractPrice' label='含税合同价' width="90" align='center' show-overflow-tooltip/>
        <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center' width="130" show-overflow-tooltip/>
        <el-table-column prop='difPrice' label='差价' align='center' show-overflow-tooltip/>
        <el-table-column label='是否生成对账单' prop='isReconciliation' align='center' width="150"
                         :formatter='isReconciliationFormat' />
        <el-table-column prop='settNo' label='对账单编号' width='160px' align='center'
                         show-overflow-tooltip/>
        <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                         show-overflow-tooltip>
          <template slot-scope='scope'>
            {{ scope.row.title ? scope.row.title : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop='actNoSub' label='原结算对账编号' width='160px' align='center'
                         show-overflow-tooltip/>
        <el-table-column prop='titleSub' label='原结算对账标题' width='160px' align='center'
                         show-overflow-tooltip/>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 生成对账单 -->
    <supplier-statement ref='supplierStatementRef' @clearSelectedData='clearSelectedData' />
    <!-- 修改台账月 -->
    <modify-ledger-month ref='modifyLedgerMonthRef' @clearSelectedData='clearSelectedData' />
  </div>
</template>

<script>
import supplierStatement
  from '@/views/settle/supplier/supplier-port-warehouse-settlement/components/supplierStatement';
import ModifyLedgerMonth
  from '@/views/settle/supplier/supplier-port-warehouse-settlement/components/modifyLedgerMonth';
import {
  supplierPortWarehouseSettlementAddRefresh,
  supplierPortWarehouseSettlementList, supplierPortWarehouseSettlementPageList,
  supplierPortWarehouseSettlementRefresh,
} from '@/service/warehouse';
import { getSessionStore } from '@/config/mUtils';
import { baseUrl } from '@/config/env';
import BatchImport from '@/components/batchImport';
import ImportStatement from "@/views/settle/entrust/components/import-statement.vue";
import {addSettlementFreight} from "@/service/basicfile";

export default {
  name: 'supplierPortWarehouseSettlement',
  components: {
    ImportStatement,
    ModifyLedgerMonth,
    supplierStatement,
    BatchImport,
  },
  data() {
    return {
      importLoading: false,
      searchForm: {
        supplierName: '',
        name: '',
        settlementType: '',
        standingBookMonth: '',
        brand: '',
        isReconciliation: '',
        actNoSub: '',
        titleSub: '',
        page: 1,
        rows: 10,
      },
      defaultSearchForm: {},
      tableLoading: false,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      total: 0,
      xxxOptions: [{
        value: 1,
        label: 1,
      }, {
        value: 2,
        label: 2,
      },
      ],
      selectedData: [],
      tipOne: true,
      settlement: '',
      uploadUrl: '/settlement/supplierPortAndWarehouse/add/importExcel',
    };
  },
  mounted() {
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
    //this.searchBtn();
  },
  methods: {
    /**
     * 生成对账单
     */
    generateStatement() {
      if (this.selectedData.length === 0) return this.$message.warning('请选择数据后生成对账单');
      let taxFlag = false; // 税率
      if (this.selectedData.length > 0) {
        const {
          taxRate,
        } = this.selectedData[0];
        this.selectedData.forEach((item) => {
          if (item.taxRate !== taxRate) {
            taxFlag = true;
          }
        });
      }
      this.$refs.supplierStatementRef.dialogOpen(this.selectedData);
    },
    /**
     * 修改台账月
     */
    modifyLedgerMonth() {
      if (!this.selectedData.length || this.selectedData.length === 0) return this.$message.warning('请选择至少一条数据！');
      if (this.selectedData.length > 100) return this.$message.warning('最多选择100条数据！');
      this.$refs.modifyLedgerMonthRef.dialogOpen(this.selectedData);
    },
    // 结算类型格式化
    settlementTypeFormat(row, column, cellValue) {
      switch (cellValue) {
        case 0:
          return '库房';
        case 1:
          return '港口';
      }
    },
    // 结算方式格式化
    settlementStyleFormat(row, column, cellValue) {
      switch (cellValue) {
        case 0:
          return '预结算价';
        case 1:
          return '合同价';
      }
    },
    // 是否生成对账单格式化
    isReconciliationFormat(row, column, cellValue) {
      switch (cellValue) {
        case 0:
          return '否';
        case 1:
          return '是';
        case 2:
          return '部分生成';
      }
    },
    download() {
      window.location.href = '/file/港口库房供应商结算导入模板.xlsx';
    },
    // 查询
    searchBtn() {
      this.searchForm.page = 1;
      this.getTableData();
    },
    changeImportLoading(flag) {
      this.importLoading = flag;
    },
    // 重置
    resetBtn() {
      this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
    },
    //刷新补结算
    async refreshBtn() {
      this.tableLoading = true;
      const {
        status,
        message,
      } = await supplierPortWarehouseSettlementAddRefresh(this.searchForm);
      this.tableLoading = false;
      if (status !== 0) return this.$message.warning(message);
      await this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true;
      const {
        status,
        message,
        data,
      } = await supplierPortWarehouseSettlementPageList(this.searchForm);
      this.tableLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.tableData = data.records;
      this.total = data.total;
    },
    /**
     * 删除
     * @param id 当前选中数据 id
     */
    deleteData(id) {
      this.$confirm('确认删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
        })
        .catch(() => {
        });
    },
    /**
     * 提交/批量提交
     * @param id 当前选中数据 id
     */
    batchSubmission(id) {
      this.$confirm('确认提交当前选中数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          console.log(id);
          this.selectedData = [];
          this.$refs.registerTable.clearSelection();
        })
        .catch(() => {
        });
    },
    rowStyle({ row }) {
      return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    selectionChange(selectionRow) {
      if (!this.tipOne) {
        this.tipOne = true;
        this.selectedData = [];
        this.$refs.registerTable.clearSelection();
      } else {
        this.selectedData = selectionRow;
        let supplierName = '', // 供应商
          settlementType = '', // 类算类型
          settlementStyle = ''; // 结算方式
        const array = selectionRow.filter((item, index) => {
          if (index === 0) {
            supplierName = item.supplierName;
            settlementType = item.settlementType;
            settlementStyle = item.settlementStyle;
          }
          console.log(supplierName, settlementType);
          return supplierName !== item.supplierName || settlementType !== item.settlementType || settlementStyle !== item.settlementStyle;
        });
        console.log(array);
        // 筛选  供应商相同数据
        this.selectedData = selectionRow.filter(item => supplierName === item.supplierName && settlementType === item.settlementType && settlementStyle === item.settlementStyle);
        console.log(this.selectedData);
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          if (this.tipOne) {
            this.$message.warning('只能选择相同的供应商和结算类型');
            this.tipOne = false;
          }
          this.$refs.registerTable.toggleRowSelection(this.tableData.find(item => value.id === item.id), false);
        });
      }
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
    clearSelectedData() {
      this.selectedData = [];
      this.$refs.registerTable.clearSelection();
      this.searchBtn();
    },
    // 导出数据
    exportData() {
      // let token = getSessionStore('token');
      const {
        supplierName,
        name,
        settlementType,
        standingBookMonth,
        brand,
        isReconciliation,
        actNoSub,
        titleSub,
      } = this.searchForm;
      // window.location.href = `${baseUrl}/platform/settlement/supplierPortAndWarehouse/add/exportExcel?access_token=${token}&supplierName=${supplierName}&name=${name}&settlementType=${settlementType}&standingBookMonth=${standingBookMonth}&brand=${brand}&isReconciliation=${isReconciliation}&actNoSub=${actNoSub}&titleSub=${titleSub}`;
      window.exportExcelGet('/platform/settlement/supplierPortAndWarehouse/add/exportExcel', `supplierName=${supplierName}&name=${name}&settlementType=${settlementType}&standingBookMonth=${standingBookMonth}&brand=${brand}&isReconciliation=${isReconciliation}&actNoSub=${actNoSub}&titleSub=${titleSub}`);
    },
  },
};
</script>


<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 15px;
  margin-top: 5px;

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }

  .content {
    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-top: 10px;

      span {
        font-size: 13px;
      }
    }
  }
}
</style>
